// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CZit","clinicsSelect":"styles_clinicsSelect__17Ft8"};